<template>
  <div class="content">
    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="ICCIDS/组网号"  prop="iccids" label-width="151px">
        <el-input
          v-model="ruleForm.iccids"
          type="textarea"
          placeholder="请输入ICCIDS/组网号"
          rows="6"
          style="width:420px"
          @input="changeRecoveryIccids"
        ></el-input>
        <div class="card-num" v-if="recoveryIccidsCount>0"><span>{{ $t('app.recovery.totalCount') }}</span><span>{{recoveryIccidsCount}}</span></div>
      </el-form-item>
      <el-form-item label="ICCID/组网号范围"  prop="startIccid" label-width="151px">
        <el-input
          v-model="ruleForm.startIccid"
          style="width: 200px;margin-right: 10px;"
          placeholder="ICCID/组网号开始值"
          @input = "changeRecoveryIccidRange"
        ></el-input>
        <span>-</span>
        <el-input
          v-model="ruleForm.endIccid"
          style="width: 200px;margin-left: 10px;"
          placeholder="ICCID/组网号结束值"
          @input = "changeRecoveryIccidRange"
        ></el-input>
        <div class="card-num" v-if="recoveryIccidRangeCount>0"><span>{{ $t('app.recovery.totalCount') }}</span><span>{{recoveryIccidRangeCount}}</span></div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="submit()" >{{ $t('app.common.submit') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { cardRecycling , selectCount} from "@/api/api.js";
export default {
  name:"multiNetRecycle",
  data() {
    return {
      ruleForm: {
        fieldType:'1',
        iccids:'',
        startIccid:'',
        endIccid:'',
      },
      submitLoading:false,
      //批量卡统计
      recoveryIccidsCount:0,
      //号段统计
      recoveryIccidRangeCount:0,

    };
  },
  watch:{
    $route: {
      handler: function(to, from){
        if(to.name == 'recovery'){
          let iccids = this.$route.params.iccids;
          if(!!iccids){
            this.$set(this.ruleForm,"iccids",iccids);
            this.changeRecoveryIccids()
          }
        }
      },
      deep: true
    }
  },
  computed: {
    adminShow(){
        return this.$store.getters.user.userType =='1'
    },
  },
  methods: {
    submit() {
      let { iccids } = this.ruleForm;
      let data = {
        ...this.ruleForm,
        iccids:iccids ? iccids.split("\n") : []
      };
      cardRecycling(data).then(res => {
        this.$notify.info({
            title: this.$t('app.common.tip'),
            message: this.$t('app.recovery.submitSuccess'),
            duration: 1000,
            offset:30
          });
          setTimeout(()=>{
            this.ruleForm ={
              fieldType:'1',
              iccids:'',
              startIccid:'',
              endIccid:'',
            };
            this.recoveryIccidsCount = 0
            this.recoveryIccidRangeCount = 0
            this.$router.push({ path: `/taskCenter/missionList`});
          },1000)
      });
    },
    changeRecoveryIccids(){
      let arrIccids = this.ruleForm.iccids ? this.ruleForm.iccids.split("\n") : []
      this.recoveryIccidsCount = arrIccids.filter(item=>!!item).length
    },
    changeRecoveryIccidRange(){
      this.recoveryIccidRangeCount = 0
      let fieldType = this.ruleForm.fieldType
      if(!!this.ruleForm.startIccid && !!this.ruleForm.endIccid){
            if(this.ruleForm.fieldType === '1'  && this.ruleForm.startIccid.length>8 && this.ruleForm.endIccid.length>8){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.recoveryIccidRangeCount = res.data.data
              })
            }
            if(this.ruleForm.fieldType === '2'  && this.ruleForm.startIccid.length>8 && this.ruleForm.endIccid.length>8){
              let startIccid = this.ruleForm.startIccid
              let endIccid =  this.ruleForm.endIccid
              selectCount({fieldType,startIccid,endIccid}).then(res=>{
                this.recoveryIccidRangeCount = res.data.data
              })
            }
      }

    }
  },
  created() {
    let iccids = this.$route.params.iccids;
    if(!!iccids){
      this.$set(this.ruleForm,"iccids",iccids);
      let arrIccids = iccids.split("\n")
      this.recoveryIccidsCount = arrIccids.filter(item=>!!item).length
      this.changeRecoveryIccidRange()
    }
  },
};
</script>
<style scoped lang="less">
.card-num{
    height: 20px;
    line-height: 20px;
    span:nth-of-type(2){
      color:red
    }
  }
</style>
